import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';

export type CheckoutFormType = 'PICKUP' | 'DELIVERY' | 'COUPON_ONLY';

@Component({
  selector: 'app-checkout-delivery-form',
  templateUrl: './checkout-delivery-form.component.html',
  styleUrls: ['./checkout-delivery-form.component.scss']
})
export class CheckoutDeliveryFormComponent {
  @Input() form: FormGroup;
  @Input() formType: CheckoutFormType = 'DELIVERY';
  @Input() minDate: Date;
  @Input() dateFilter: (d: Date) => boolean;
  @Input() hasCoupon = false;
  @Input() hasDifferent = false;

  @Output() formTypeChange = new EventEmitter<CheckoutFormType>();
  @Output() dateChange = new EventEmitter<MatDatepickerInputEvent<Date>>();

  readonly timeSlots: string[] = [
    '12:00:00', '12:30:00', '13:00:00', '13:30:00',
    '14:00:00', '14:30:00', '15:00:00', '15:30:00',
    '16:00:00', '16:30:00', '17:00:00', '17:30:00',
    '18:00:00', '18:30:00', '19:00:00', '19:30:00', '20:00:00'
  ];

  readonly stores: string[] = [
    $localize`:@@checkout.delivery.stores.mongkok:CHEZ CHOUX 旺角港鐵站分店`,
    // 'CHEZ CHOUX 旺角朗豪坊分店', // hidden per b4da393 (matches legacy hide on prod)
    $localize`:@@checkout.delivery.stores.kwuntong:CHEZ CHOUX 觀塘港鐵站分店`,
    $localize`:@@checkout.delivery.stores.tuenmun:CHEZ CHOUX 屯門港鐵站分店`,
    $localize`:@@checkout.delivery.stores.mostown:CHEZ CHOUX 馬鞍山 MOSTown 分店`,
    $localize`:@@checkout.delivery.stores.shatin:CHEZ CHOUX 沙田港鐵站分店`,
    $localize`:@@checkout.delivery.stores.fanling:CHEZ CHOUX 粉嶺港鐵站分店`
  ];

  selectType(type: CheckoutFormType): void {
    if (type === this.formType) return;
    this.formType = type;
    this.formTypeChange.emit(type);
  }

  onDateChange(e: MatDatepickerInputEvent<Date>): void {
    this.dateChange.emit(e);
  }

  ctrl(name: string) { return this.form ? this.form.get(name) : null; }

  shouldShowError(name: string): boolean {
    const c = this.ctrl(name);
    return !!c && c.invalid && (c.dirty || c.touched);
  }
}
